export enum TIME_CONSTANTS_IN_SECONDS {
  ONE_SECOND = 1,
  ONE_MINUTE = ONE_SECOND * 60,
  TEN_MINUTES = ONE_MINUTE * 10,
  THIRTY_MINUTES = ONE_MINUTE * 30,
  ONE_HOUR = ONE_MINUTE * 60,
  ONE_DAY = ONE_HOUR * 24,
  WEEK = ONE_DAY * 7,
  THIRTY_DAYS = ONE_DAY * 30,
  ONE_YEAR = ONE_DAY * 365,
}

export enum TIME_CONSTANTS_IN_MS {
  ONE_SECOND = 1000,
  ONE_MINUTE = ONE_SECOND * 60,
  TEN_MINUTES = ONE_MINUTE * 10,
  THIRTY_MINUTES = ONE_MINUTE * 30,
  ONE_HOUR = ONE_MINUTE * 60,
  ONE_DAY = ONE_HOUR * 24,
  WEEK = ONE_DAY * 7,
  THIRTY_DAYS = ONE_DAY * 30,
  ONE_YEAR = ONE_DAY * 365,
}
